import { Component, OnInit } from "@angular/core";

@Component({
    selector: "dodo-modal-background",
    templateUrl: "./modal-background.component.html",
    styleUrls: ["./modal-background.component.scss"],
    standalone: false
})
export class ModalBackgroundComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
